export default "/images/e91552707dc934ac6a03e2126684acd6.avif";